//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },

    data () {
        return {
            dialogVisible: this.value,
            loading: false,
            rules: {},
            form: {
                email: ''
            },
            activeSelection: '',
            selections: [
                'teacher',
                'guest'
            ]
        };
    },

    watch: {
        dialogVisible () {
            this.$emit('input', this.dialogVisible);

            if (this.dialogVisible) {
                this.activeSelection = '';
                this.form.email = '';
            }
        },
        value () {
            this.dialogVisible = this.value;
        }
    },

    methods: {
        registerTeacher () {
            this.loading = true;

            axios.post('users/register', {
                email: this.form.email
            }).then(response => {
                this.$message({
                    type: 'success',
                    message: response.data.message
                });
                this.loading = false;
                this.dialogVisible = false;
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
            }).catch(error => {
                if (error.response.status === 422) {
                    this.$helper.FormValidator.validate(this.$refs.form, this.form, this.rules, error.response.data.errors);
                }

                this.loading = false;
            });
        },
        registerGuest () {
            this.loading = true;

            axios.post('guest/register', {
                email: this.form.email
            }).then(response => {
                this.loading = false;
                this.dialogVisible = false;
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();

                if (response.data.redirect) {
                    window.location.href = response.data.redirect;
                }
            }).catch(error => {
                if (error.response.status === 422) {
                    this.$helper.FormValidator.validate(this.$refs.form, this.form, this.rules, error.response.data.errors);
                }

                this.loading = false;
            });
        }
    }
};
